
import _ from "lodash"
import Sticky from "./components/sticky"
import { addClass, removeClass } from "./shared/dom"

export default {
  name: "FloorWrapper",
  components: { Sticky },
  props: {
    type: String
  },
  data() {
    return {
      offsetTop: 0,
      onDebounceScroll: () => {}
    }
  },
  computed: {},
  mounted() {
    const topBox = document.getElementById("top-box")
    // 判断为导航控件，则计算导航相对偏移量
    if (this.type === "navigate") {
      this.offsetTop = topBox.clientHeight
    }
    this.throttleUpdateNavPosition = _.debounce(this.updateNavPosition, 100)
    this.onDebounceScroll = _.debounce(this.onScroll, 100)
  },
  methods: {
    onScroll({ isFixed }) {
      const topBox = document.getElementById("top-box")
      const topWrapper = document.getElementById("top-content-wrapper")
      const wellcomeBgWrapper = document.getElementById("wellcome-bg-wrapper")
      this.offsetTop = topBox.clientHeight

      if (isFixed) {
        addClass(document.body, "nav__fixed")
        this.throttleUpdateNavPosition()
      } else {
        removeClass(document.body, "nav__fixed")
        topWrapper.style.minHeight = 0
        wellcomeBgWrapper.style.minHeight = 0
      }
    },
    updateNavPosition() {
      const topWrapper = document.getElementById("top-content-wrapper")
      const wellcomeBgWrapper = document.getElementById("wellcome-bg-wrapper")
      const sticky = document.querySelector(".sticky")
      if (topWrapper && sticky) {
        // topWrapper.style.minHeight = `${parseFloat(topWrapper.style.height) + 0.15}rem`
        // wellcomeBgWrapper.style.minHeight = `${parseFloat(wellcomeBgWrapper.style.height) + 0.15}rem`
        sticky.style.top = `${parseFloat(topWrapper.style.height)}rem`
        // sticky.style.top = `${parseFloat(topWrapper.style.height) + 0.15}rem`
      }
    }
  }
}
